module.exports = __webpack_public_path__ + "img/14.bb3696ae.png";